/**
 * LabelMakerPage — thin page wrapper around the LabelMaker tool.
 * Provides consistent navigation chrome (Back to Calculators) around
 * the shared LabelMaker component so it can be used inline in the
 * admin workstation OR opened full-screen from the Calculators hub.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LabelMaker from '../components/tools/LabelMaker';
import ThemeToggle from '../components/ThemeToggle';

export default function LabelMakerPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 border-b border-border bg-background/95 backdrop-blur no-print">
        <div className="container mx-auto px-6 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate('/calculators')}
            className="inline-flex items-center gap-2 text-sm font-semibold text-foreground/80 hover:text-foreground"
            data-testid="label-maker-back"
          >
            <ArrowLeft className="w-4 h-4" /> Calculators &amp; Tools
          </button>
          <h1 className="font-heading text-lg font-extrabold tracking-tight text-foreground">
            Label Maker
          </h1>
          <ThemeToggle />
        </div>
      </header>
      <main className="py-6">
        <LabelMaker />
      </main>
    </div>
  );
}
